<template>
  <div class="card mb-3">
    <div class="card-header">
      <h5 class="mb-0">{{ translation_key.key }} <span class="badge badge-primary float-right"><i class="fas fa-tag mr-2"></i>{{ translation_key.tag }}</span></h5>
    </div>
    <div class="list-group list-group-flush">
      <TranslationGroup  v-for="[locale, translations] in translation_groups"
                        :key="locale.locale"
                        :translations="translations"
                        :locale="locale"
                        :scope="scope"
                        :translation_key="translation_key"
      />
    </div>
  </div>

</template>

<script>

    import Translation from "./Translation"
    import TranslationGroup from "./TranslationGroup"
    export default {
        name: "TranslationsEditor",
      components: {TranslationGroup, Translation},
      props: {
            translation_key: Object,
            translation_groups: Array,
            locales: Array,
            scope: Object
        }
    }
</script>